
import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";


export interface QueryWeekdayCumulativeAverageRequestParamsDto {
    appIds: string[];
    startTime: string;
    endTime: string;
    weekday?: string;
    granularity?: CubeTimeDimensionGranularity;
}